
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.0
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $a850018c3a931852$var$desktopMaxVisibleCards = 3;
const $a850018c3a931852$var$phoneMaxVisibleCards = 1;
const $a850018c3a931852$var$positionZones = [
    {
        top: [
            8,
            24
        ],
        left: [
            8,
            32
        ]
    },
    {
        top: [
            8,
            26
        ],
        left: [
            60,
            78
        ]
    },
    {
        top: [
            55,
            74
        ],
        left: [
            10,
            34
        ]
    },
    {
        top: [
            56,
            76
        ],
        left: [
            58,
            78
        ]
    }
];
const $a850018c3a931852$var$randomBetween = ([min, max])=>Math.round(min + Math.random() * (max - min));
const $a850018c3a931852$var$randomDelay = ()=>$a850018c3a931852$var$randomBetween([
        1400,
        6200
    ]);
const $a850018c3a931852$var$shortDelay = ()=>$a850018c3a931852$var$randomBetween([
        350,
        900
    ]);
const $a850018c3a931852$var$isPhoneView = ()=>window.matchMedia("(max-width: 37.5em)").matches;
const $a850018c3a931852$var$maxVisibleCards = ()=>$a850018c3a931852$var$isPhoneView() ? $a850018c3a931852$var$phoneMaxVisibleCards : $a850018c3a931852$var$desktopMaxVisibleCards;
const $a850018c3a931852$var$shuffle = (items)=>{
    const shuffled = [
        ...items
    ];
    for(let index = shuffled.length - 1; index > 0; index -= 1){
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[swapIndex]] = [
            shuffled[swapIndex],
            shuffled[index]
        ];
    }
    return shuffled;
};
const $a850018c3a931852$var$isCardDisplayable = (card)=>window.getComputedStyle(card).display !== "none";
const $a850018c3a931852$var$randomAvailableZone = (activeZones)=>{
    const availableZones = $a850018c3a931852$var$positionZones.map((_, index)=>index).filter((zoneIndex)=>!activeZones.has(zoneIndex));
    return availableZones[Math.floor(Math.random() * availableZones.length)];
};
const $a850018c3a931852$var$getContentBoundary = (hero)=>{
    const title = hero.querySelector(".hero-title");
    const cta = hero.querySelector(".hero-cta");
    const heroRect = hero.getBoundingClientRect();
    const rects = [
        title,
        cta
    ].filter(Boolean).map((element)=>element.getBoundingClientRect());
    const padding = 48;
    const mobilePadding = 28;
    const boundaryPadding = $a850018c3a931852$var$isPhoneView() ? mobilePadding : padding;
    return {
        top: Math.min(...rects.map((rect)=>rect.top)) - heroRect.top - boundaryPadding,
        right: Math.max(...rects.map((rect)=>rect.right)) - heroRect.left + boundaryPadding,
        bottom: Math.max(...rects.map((rect)=>rect.bottom)) - heroRect.top + boundaryPadding,
        left: Math.min(...rects.map((rect)=>rect.left)) - heroRect.left - boundaryPadding
    };
};
const $a850018c3a931852$var$hasOverlap = (firstRect, secondRect)=>firstRect.left < secondRect.right && firstRect.right > secondRect.left && firstRect.top < secondRect.bottom && firstRect.bottom > secondRect.top;
const $a850018c3a931852$var$getTravelRects = ({ centerX: centerX, top: top, width: width, height: height, startX: startX, startY: startY, endX: endX, endY: endY })=>[
        {
            top: top + startY,
            right: centerX - width / 2 + startX + width,
            bottom: top + startY + height,
            left: centerX - width / 2 + startX
        },
        {
            top: top + endY,
            right: centerX - width / 2 + endX + width,
            bottom: top + endY + height,
            left: centerX - width / 2 + endX
        }
    ];
const $a850018c3a931852$var$getSafePlacement = (hero, card, zoneIndex)=>{
    const heroRect = hero.getBoundingClientRect();
    const contentBoundary = $a850018c3a931852$var$getContentBoundary(hero);
    const zone = $a850018c3a931852$var$positionZones[zoneIndex];
    const cardRect = card.getBoundingClientRect();
    const cardWidth = cardRect.width || ($a850018c3a931852$var$isPhoneView() ? 150 : 360);
    const cardHeight = cardRect.height || ($a850018c3a931852$var$isPhoneView() ? 110 : 260);
    const contentCenterX = (contentBoundary.left + contentBoundary.right) / 2;
    const contentCenterY = (contentBoundary.top + contentBoundary.bottom) / 2;
    for(let attempt = 0; attempt < 24; attempt += 1){
        const centerX = $a850018c3a931852$var$randomBetween(zone.left) / 100 * heroRect.width;
        const top = $a850018c3a931852$var$randomBetween(zone.top) / 100 * heroRect.height;
        const driftDirectionX = centerX < contentCenterX ? -1 : 1;
        const driftDirectionY = top + cardHeight / 2 < contentCenterY ? -1 : 1;
        const driftX = driftDirectionX * $a850018c3a931852$var$randomBetween($a850018c3a931852$var$isPhoneView() ? [
            36,
            64
        ] : [
            72,
            120
        ]);
        const driftY = driftDirectionY * $a850018c3a931852$var$randomBetween($a850018c3a931852$var$isPhoneView() ? [
            28,
            52
        ] : [
            48,
            88
        ]);
        const startX = Math.round(driftX * -0.35);
        const startY = Math.round(driftY * -0.35);
        const endX = driftX;
        const endY = driftY;
        const travelRects = $a850018c3a931852$var$getTravelRects({
            centerX: centerX,
            top: top,
            width: cardWidth,
            height: cardHeight,
            startX: startX,
            startY: startY,
            endX: endX,
            endY: endY
        });
        if (!travelRects.some((rect)=>$a850018c3a931852$var$hasOverlap(rect, contentBoundary))) return {
            centerX: centerX,
            top: top,
            startX: startX,
            startY: startY,
            endX: endX,
            endY: endY
        };
    }
    const fallbackCenterX = zone.left[1] < 50 ? cardWidth : heroRect.width - cardWidth;
    const fallbackTop = zone.top[1] < 50 ? 32 : heroRect.height - cardHeight - 32;
    return {
        centerX: fallbackCenterX,
        top: fallbackTop,
        startX: zone.left[1] < 50 ? 32 : -32,
        startY: zone.top[1] < 50 ? 24 : -24,
        endX: zone.left[1] < 50 ? -96 : 96,
        endY: zone.top[1] < 50 ? -72 : 72
    };
};
const $a850018c3a931852$var$prepareCard = (card, zoneIndex)=>{
    const hero = document.querySelector("#hero");
    const placement = $a850018c3a931852$var$getSafePlacement(hero, card, zoneIndex);
    const rotation = $a850018c3a931852$var$randomBetween([
        -8,
        8
    ]);
    const duration = $a850018c3a931852$var$randomBetween([
        13500,
        24500
    ]);
    card.style.setProperty("--hero-card-top", `${placement.top}px`);
    card.style.setProperty("--hero-card-left", `${placement.centerX}px`);
    card.style.setProperty("--hero-card-rotation", `${rotation}deg`);
    card.style.setProperty("--hero-card-start-x", `${placement.startX}px`);
    card.style.setProperty("--hero-card-start-y", `${placement.startY}px`);
    card.style.setProperty("--hero-card-end-x", `${placement.endX}px`);
    card.style.setProperty("--hero-card-end-y", `${placement.endY}px`);
    card.style.setProperty("--hero-card-duration", `${duration}ms`);
};
function $a850018c3a931852$export$2e2bcd8739ae039() {
    const cards = [
        ...document.querySelectorAll(".hero-bg-card")
    ];
    const activeCards = new Set();
    const activeZones = new Set();
    let reviewDeck = [];
    let pendingSpawn = null;
    if (!cards.length) return;
    const drawCard = ()=>{
        if (!reviewDeck.length) reviewDeck = $a850018c3a931852$var$shuffle(cards.filter((card)=>!activeCards.has(card) && $a850018c3a931852$var$isCardDisplayable(card)));
        const card = reviewDeck.find((deckCard)=>!activeCards.has(deckCard));
        reviewDeck = reviewDeck.filter((deckCard)=>deckCard !== card);
        return card;
    };
    const spawnCard = ()=>{
        if (activeCards.size >= $a850018c3a931852$var$maxVisibleCards()) return;
        const card = drawCard();
        const zoneIndex = $a850018c3a931852$var$randomAvailableZone(activeZones);
        if (!card || zoneIndex === undefined) return;
        $a850018c3a931852$var$prepareCard(card, zoneIndex);
        activeCards.add(card);
        activeZones.add(zoneIndex);
        card.classList.remove("is-floating");
        card.offsetHeight;
        card.classList.add("is-floating");
        card.addEventListener("animationend", ()=>{
            card.classList.remove("is-floating");
            activeCards.delete(card);
            activeZones.delete(zoneIndex);
            if (activeCards.size === 0) {
                scheduleNext($a850018c3a931852$var$shortDelay());
                return;
            }
            scheduleNext($a850018c3a931852$var$randomDelay());
        }, {
            once: true
        });
    };
    const scheduleNext = (delay = $a850018c3a931852$var$randomDelay())=>{
        if (pendingSpawn) return;
        pendingSpawn = window.setTimeout(()=>{
            pendingSpawn = null;
            if (activeCards.size >= $a850018c3a931852$var$maxVisibleCards()) {
                scheduleNext($a850018c3a931852$var$randomDelay());
                return;
            }
            spawnCard();
            if (activeCards.size > 0 && activeCards.size < $a850018c3a931852$var$maxVisibleCards() && Math.random() > 0.45) scheduleNext($a850018c3a931852$var$randomDelay());
        }, delay);
    };
    spawnCard();
    scheduleNext($a850018c3a931852$var$randomBetween([
        900,
        2400
    ]));
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__tidbit",
        animation: {
            delay: 700,
            interval: 180,
            distance: "16px",
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".social-links",
        animation: {
            delay: 1050,
            origin: "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    }
];


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
(0, $a850018c3a931852$export$2e2bcd8739ae039)();


//# sourceMappingURL=portfolioWebsite.9b418675.js.map
